import { useState, useEffect } from 'react';
import permissionService from '../../../../services/permissionService';

export function usePermissions() {
  const [permissions, setPermissions] = useState<string[]>([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        const res = await permissionService.getMyPermissions();
        setPermissions(res.data.permissions);
        setIsAdmin(res.data.isAdmin);
      } catch (error) {
        console.error('Error loading permissions:', error);
        setPermissions([]);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    loadPermissions();
  }, []);

  const hasPermission = (permission: string | string[]): boolean => {
    if (isAdmin) return true; // Admin có tất cả quyền
    
    if (Array.isArray(permission)) {
      // Nếu là array, kiểm tra xem có ít nhất một permission nào có trong danh sách không
      return permission.some(perm => permissions.includes(perm));
    }
    
    return permissions.includes(permission);
  };

  return {
    permissions,
    isAdmin,
    isLoading,
    hasPermission
  };
}

